<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <label>Família</label>
                  <input
                    type="text"
                    id="familia"
                    class="form-control"
                    v-model="familia.nome"
                  />
                </div>

                <div class="col-md-4">
                  <label>SubGrupo</label>
                  <v-select
                    :options="sub_grupos"
                    :reduce="(sub_grupos) => sub_grupos.id"
                    :label="'nome'"
                    v-model="familia.subgrupo_id"
                    class="vselect"
                  ></v-select>
                </div>

                <div class="col-md-4">
                  <label> Status </label>
                  <select v-model="familia.ativo" class="form-control">
                    <option :value="1">Ativo</option>
                    <option :value="0">Inativo</option>
                  </select>
                </div>

                <div class="col-md-12">
                  <label>Descrição</label>
                  <textarea
                    cols="30"
                    rows="10"
                    class="form-control"
                    v-model="familia.descricao"
                  ></textarea>
                </div>
                <div class="col-md-12 text-right">
                  <hr />
                  <router-link to="/familias" class="btn btn-back mr-1">
                    <i class="fa fa-arrow-left" />
                    Voltar
                  </router-link>
                  <a class="btn btn-add" @click="save">
                    Salvar
                    <i class="fa fa-save" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      familia: {},
      sub_grupos: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "familias";

      self.$loading(true);

      if (self.familia.id) {
        api += "/" + self.familia.id;
        self.familia._method = "PUT";
      }

      axios
        .post(api, self.familia)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/familias");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    getFamilia: function (id) {
      const self = this;
      const api = self.$store.state.api + "familias/" + id;

      axios
        .get(api)
        .then((response) => {
          self.familia = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSubGrupos: function () {
      const self = this;
      const api = self.$store.state.api + "sub_grupos";

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.sub_grupos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getSubGrupos();
    $("#familia").focus();

    let id = self.$route.params.id;
    if (id) {
      self.getFamilia(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>